// ============================================================
// NOVATEK INDUSTRIAL SYSTEMS - UNIVERSAL API & MEDIA CLIENT
// Auto-detects Localhost & cPanel Hosting environments seamlessly
// ============================================================

(function() {
  // Determine subdirectory dynamically (e.g., /novatek)
  const getSubfolder = () => {
    const path = window.location.pathname;
    if (path && path !== '/' && !path.endsWith('.html') && !path.includes('.')) {
      const cleanPath = path.replace(/\/+$/, '');
      const segments = cleanPath.split('/').filter(Boolean);
      const knownPages = ['home', 'industries', 'products', 'product-detail', 'category', 'about', 'blogs', 'careers', 'india', 'downloads', 'contact', 'support', 'admin'];
      
      // Filter out known page segments from the end to isolate the actual subfolder
      while (segments.length > 0 && knownPages.includes(segments[segments.length - 1])) {
        segments.pop();
      }
      
      if (segments.length > 0) {
        return '/' + segments.join('/');
      }
    }
    return '';
  };

  // Determine API base URL dynamically based on environment
  const determineBaseUrl = () => {
    const sub = getSubfolder();
    return sub ? `${sub}/backend/api` : '/api';
  };

  window.apiClient = {
    baseUrl: determineBaseUrl(),

    async request(endpoint, options = {}) {
      // Clean up endpoint string (remove leading slash if present)
      const cleanEndpoint = endpoint.replace(/^\/+/, '');
      
      const config = {
        headers: {
          Accept: 'application/json',
          ...(options.headers || {})
        },
        credentials: 'same-origin',
        ...options
      };

      if (options.body && !(options.body instanceof FormData) && typeof options.body === 'object') {
        config.headers['Content-Type'] = 'application/json';
        config.body = JSON.stringify(options.body);
      }

      let response;
      const sub = getSubfolder();
      const targetUrls = [
        `${this.baseUrl}/${cleanEndpoint}`,
        `${sub}/api/${cleanEndpoint}`,
        `${sub}/backend/api/${cleanEndpoint}`,
        `${sub}/api/v1/${cleanEndpoint}`
      ];

      let lastError = null;
      for (const targetUrl of targetUrls) {
        try {
          response = await fetch(targetUrl, config);
          if (response.status !== 404) {
            break; // Valid endpoint reached
          }
        } catch (err) {
          lastError = err;
        }
      }

      if (!response) {
        throw new Error('Unable to connect to the backend server. Please check your PHP/MySQL configuration.');
      }

      const contentType = response.headers.get('content-type') || '';
      let payload = null;
      if (contentType.includes('application/json')) {
        payload = await response.json();
      }

      if (!payload) {
        if (response.ok) {
          return { success: true, status: response.status };
        }
        throw new Error(`Backend API returned unexpected response (${response.status}).`);
      }

      if (!response.ok || payload.success === false) {
        throw new Error(payload?.message || `Server request failed (${response.status}).`);
      }

      return payload;
    },

    get(endpoint, params = {}) {
      const queryString = new URLSearchParams(params).toString();
      const url = queryString ? `${endpoint}?${queryString}` : endpoint;
      return this.request(url, { method: 'GET' });
    },

    post(endpoint, body) {
      return this.request(endpoint, { method: 'POST', body });
    },

    put(endpoint, body) {
      return this.request(endpoint, { method: 'PUT', body });
    },

    delete(endpoint, params = {}) {
      const queryString = new URLSearchParams(params).toString();
      const url = queryString ? `${endpoint}?${queryString}` : endpoint;
      return this.request(url, { method: 'DELETE' });
    },

    uploadFile(endpoint, formData) {
      return this.request(endpoint, { method: 'POST', body: formData });
    }
  };

  // ============================================================
  // UNIVERSAL MEDIA RESOLVER
  // Resolves backend image paths before and after cPanel hosting
  // ============================================================
  window.resolveMediaUrl = function(url, fallbackType = 'machine') {
    if (!url || typeof url !== 'string' || url.trim() === '') {
      return getFallbackPlaceholder(fallbackType);
    }

    const trimmed = url.trim();

    // Already an absolute external URL or data URI
    if (trimmed.startsWith('http://') || trimmed.startsWith('https://') || trimmed.startsWith('data:')) {
      return trimmed;
    }

    const sub = getSubfolder();

    // Relative storage paths
    if (trimmed.startsWith('/api/storage/') || trimmed.startsWith('api/storage/')) {
      const cleanSub = trimmed.replace(/^\/?api\/storage\//, '');
      return `${sub}/api/storage/${cleanSub}`;
    }

    if (trimmed.startsWith('/storage/') || trimmed.startsWith('storage/')) {
      const cleanSub = trimmed.replace(/^\/?storage\//, '');
      return `${sub}/api/storage/${cleanSub}`;
    }

    if (trimmed.startsWith('/uploads/') || trimmed.startsWith('uploads/')) {
      const cleanSub = trimmed.replace(/^\/?uploads\//, '');
      return `${sub}/api/storage/uploads/${cleanSub}`;
    }

    // Clean leading slash for relative assets
    if (trimmed.startsWith('/')) {
      return trimmed;
    }

    return `/${trimmed}`;
  };

  // Graceful fallback placeholders if an image is missing or broken
  function getFallbackPlaceholder(type) {
    switch (type) {
      case 'railway':
        return '/api/storage/banners/hero_railways.png';
      case 'automotive':
        return '/api/storage/banners/hero_automation.png';
      case 'aerospace':
        return '/api/storage/banners/hero_aerospace.png';
      case 'client':
        return '/logo.png';
      case 'person':
        return 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=400&q=80';
      case 'machine':
      default:
        return '/api/storage/banners/hero_railways.png';
    }
  }

  // Global Image Error Handler (prevents broken icons)
  window.handleImageError = function(e, fallbackType = 'machine') {
    if (e && e.target) {
      e.target.onerror = null; // Prevent infinite error loops
      e.target.src = getFallbackPlaceholder(fallbackType);
    }
  };

})();
